var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_436_1603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.9995 19.2C15.4201 19.2 14.8632 18.9757 14.4454 18.5743C14.0276 18.1728 13.7814 17.6252 13.7583 17.0462L13.4627 9.58125C13.4508 9.27951 13.5 8.97847 13.6073 8.69619C13.7146 8.41392 13.8777 8.15621 14.087 7.93852C14.2963 7.72083 14.5474 7.54763 14.8252 7.42932C15.1031 7.31101 15.4019 7.25002 15.7039 7.25H16.2952C16.5971 7.25002 16.896 7.31101 17.1738 7.42932C17.4517 7.54763 17.7028 7.72083 17.9121 7.93852C18.1213 8.15621 18.2845 8.41392 18.3918 8.69619C18.4991 8.97847 18.5483 9.27951 18.5364 9.58125L18.2408 17.0462C18.2177 17.6252 17.9715 18.1728 17.5537 18.5743C17.1359 18.9757 16.579 19.2 15.9995 19.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.2385 22.5109C18.2385 21.2741 17.2359 20.2715 15.9991 20.2715C14.7624 20.2715 13.7598 21.2741 13.7598 22.5109C13.7598 23.7476 14.7624 24.7502 15.9991 24.7502C17.2359 24.7502 18.2385 23.7476 18.2385 22.5109Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_436_1603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.0c44519f1baecc0fe82578f2010e2cec.svg";
export { ForwardRef as ReactComponent };